import React, { useEffect } from 'react';

import { useField } from 'formik';

import type { FreelancerAvailableTime } from 'state/remote/types';

import useGetFreelancerAvailableTime from 'state/remote/remote-freelancer/use-get-freelancer-available-time';

import AvailableDayItem from './available-day-item';

const AvailableDayList: React.FC = () => {
  const [currentWeekfield] = useField('current-week');

  const { error, data, isLoading } = useGetFreelancerAvailableTime({
    date: currentWeekfield.value,
  });

  const [field, , { setValue }] = useField('availability');

  useEffect(() => {
    if (isLoading || error) return;
    setValue(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error, isLoading]);
  return (
    <div className="flex flex-col gap-y-5 w-full">
      {field.value.map((item: FreelancerAvailableTime, index: number) => (
        <AvailableDayItem key={item.date} index={index} />
      ))}
    </div>
  );
};

export default AvailableDayList;
